import React from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import SeriesOneAnotherSeries from './fileds/SeriesOneAnotherSeries'
import { editSeriesAPI } from '../../../../../api/pack/seriesAPI'

const SeriesOneForm = ({ seriesBd, setOpen }) => {

    const [data, setData] = useState(seriesBd ? seriesBd : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        // console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        // addSupplierAPI(dataForBd).then(data => {
        //     setOpen(false)
        //     setLoading(false)
        // }).catch(e => {
        //     setError(responseError(e))
        //     setLoading(false)
        // })
    }

    const edit = (dataForBd) => {
        editSeriesAPI(dataForBd).then(data => {
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            anotherSeries: data.anotherSeries,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }


  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('anotherSeries', 'series') ?
				<SeriesOneAnotherSeries
					required={formDataProductRequiredField('anotherSeries', 'series')}
					setValidate={e => updateValidate(setValid, 'anotherSeries', e)}
					setValueForm={e => setValueForm(setData, 'anotherSeries', e)}
					forciblyValue={data && data.anotherSeries ? data.anotherSeries : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SeriesOneForm